import { AccountType } from './accountType';

export interface SingleBillingNumber {
	accountId: string;
	accountNum: string;
	accountType: AccountType;
	bAccountId: string;
	billingType: string;
	deptId?: string;
	upAccountId: string;
	userId: string;
	userType: string;
	username: string;
	accountCategory?: string;
}

const model: types.models.InputModel = {
	accountId: 'accountId',
	accountNum: 'accountNum',
	accountType: 'accountType',
	bAccountId: 'bAccountId',
	billingType: 'billingType',
	deptId: 'deptId',
	upAccountId: 'upAccountId',
	userId: 'userId',
	userType: 'userType',
	username: 'username',
	accountCategory: 'accountCategory'
};

export default model;
